// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__vDBPO","reversed":"Logo_reversed__1Bh5a"};